import {
  getPage,
  getAll,
  getDetail,
  addObj,
  deleteObj,
  searchByName,
  modifyObj,
  getMyPage,
  changeInstaller,
  batchChangeInstaller,
  uploadSimInfosFile,
  getmysiminfo,
} from '@/api/siminfoserv'

export default {
  state: {
    state_SimInfo_GetPageResult: null,
    state_SimInfo_GetAllResult: null,
    state_SimInfo_GetDetailResult: null,
    state_SimInfo_AddObjResult: null,
    state_SimInfo_DeleteObjResult: null,
    state_SimInfo_SearchByNameResult: null,
    state_SimInfo_ModifyObjResult: null,
    state_SimInfo_GetMyPageResult: null,
    state_SimInfo_ChangeInstallerResult: null,
    state_SimInfo_BatchChangeInstallerResult: null,
    state_SimInfo_UploadSimInfosFileResult: null,
    state_SimInfo_GetmysiminfoResult: null,
  },
  mutations: {
    SET_SIMINFO_GETPAGE_RESULT: (state, rst) => {
      state.state_SimInfo_GetPageResult = rst;
    },
    SET_SIMINFO_GETALL_RESULT: (state, rst) => {
      state.state_SimInfo_GetAllResult = rst;
    },
    SET_SIMINFO_GETDETAIL_RESULT: (state, rst) => {
      state.state_SimInfo_GetDetailResult = rst;
    },
    SET_SIMINFO_ADDOBJ_RESULT: (state, rst) => {
      state.state_SimInfo_AddObjResult = rst;
    },
    SET_SIMINFO_DELETEOBJ_RESULT: (state, rst) => {
      state.state_SimInfo_DeleteObjResult = rst;
    },
    SET_SIMINFO_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_SimInfo_SearchByNameResult = rst;
    },
    SET_SIMINFO_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_SimInfo_ModifyObjResult = rst;
    },
    SET_SIMINFO_GETMYPAGE_RESULT: (state, rst) => {
      state.state_SimInfo_GetMyPageResult = rst;
    },
    SET_SIMINFO_CHANGEINSTALLER_RESULT: (state, rst) => {
      state.state_SimInfo_ChangeInstallerResult = rst;
    },
    SET_SIMINFO_BATCHCHANGEINSTALLER_RESULT: (state, rst) => {
      state.state_SimInfo_BatchChangeInstallerResult = rst;
    },
    SET_SIMINFO_UPLOADSIMINFOSFILE_RESULT: (state, rst) => {
      state.state_SimInfo_UploadSimInfosFileResult = rst;
    },
    SET_SIMINFO_GETMYSIMINFO_RESULT: (state, rst) => {
      state.state_SimInfo_GetmysiminfoResult = rst;
    },
  },
  actions: {
    SimInfoServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SIMINFO_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SIMINFO_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    SimInfoServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SIMINFO_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SIMINFO_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    SimInfoServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SIMINFO_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SIMINFO_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    SimInfoServ_AddObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SIMINFO_ADDOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SIMINFO_ADDOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    SimInfoServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SIMINFO_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SIMINFO_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    SimInfoServ_SearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SIMINFO_SEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SIMINFO_SEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    SimInfoServ_ModifyObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SIMINFO_MODIFYOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SIMINFO_MODIFYOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    SimInfoServ_GetMyPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SIMINFO_GETMYPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SIMINFO_GETMYPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    SimInfoServ_ChangeInstaller({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        changeInstaller(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SIMINFO_CHANGEINSTALLER_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SIMINFO_CHANGEINSTALLER_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    SimInfoServ_BatchChangeInstaller({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        batchChangeInstaller(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SIMINFO_BATCHCHANGEINSTALLER_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SIMINFO_BATCHCHANGEINSTALLER_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    SimInfoServ_UploadSimInfosFile({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        uploadSimInfosFile(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SIMINFO_UPLOADSIMINFOSFILE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SIMINFO_UPLOADSIMINFOSFILE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    SimInfoServ_Getmysiminfo({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getmysiminfo(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SIMINFO_GETMYSIMINFO_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SIMINFO_GETMYSIMINFO_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_SimInfo_GetPageResult: state => {
      return state.state_SimInfo_GetPageResult;
    },
    get_SimInfo_GetAllResult: state => {
      return state.state_SimInfo_GetAllResult;
    },
    get_SimInfo_GetDetailResult: state => {
      return state.state_SimInfo_GetDetailResult;
    },
    get_SimInfo_AddObjResult: state => {
      return state.state_SimInfo_AddObjResult;
    },
    get_SimInfo_DeleteObjResult: state => {
      return state.state_SimInfo_DeleteObjResult;
    },
    get_SimInfo_SearchByNameResult: state => {
      return state.state_SimInfo_SearchByNameResult;
    },
    get_SimInfo_ModifyObjResult: state => {
      return state.state_SimInfo_ModifyObjResult;
    },
    get_SimInfo_GetMyPageResult: state => {
      return state.state_SimInfo_GetMyPageResult;
    },
    get_SimInfo_ChangeInstallerResult: state => {
      return state.state_SimInfo_ChangeInstallerResult;
    },
    get_SimInfo_BatchChangeInstallerResult: state => {
      return state.state_SimInfo_BatchChangeInstallerResult;
    },
    get_SimInfo_UploadSimInfosFileResult: state => {
      return state.state_SimInfo_UploadSimInfosFileResult;
    },
    get_SimInfo_GetmysiminfoResult: state => {
      return state.state_SimInfo_GetmysiminfoResult;
    },
  }
}